import {
  Dialog,
  DialogClose,
  DialogContent,
  IconButton,
  Sheet,
  SheetBody,
  SheetContent,
  SheetHeader,
} from "@suraasa/placebo-ui"
import { useMediaQuery } from "@uidotdev/usehooks"
import { Xmark } from "iconoir-react"

import Content from "./Content"

const OfferLetterAvailableDialog = ({
  open,
  handleClose,
  handleOpenSheet,
}: {
  open: boolean
  handleClose: () => void
  handleOpenSheet: () => void
}) => {
  const isSmDown = useMediaQuery("only screen and (max-width : 640px)")

  if (isSmDown) {
    return (
      <Sheet open={open} onOpenChange={handleClose}>
        <SheetContent
          height={70}
          className="!h-fit max-w-none rounded-t-2xl bg-white !p-0"
        >
          <SheetBody>
            <SheetHeader>
              <span />
            </SheetHeader>

            <Content handleViewOfferLetter={handleOpenSheet} />
          </SheetBody>
        </SheetContent>
      </Sheet>
    )
  }
  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="rounded-2xl">
        <DialogClose className="absolute right-2 top-2">
          <IconButton color="black">
            <Xmark />
          </IconButton>
        </DialogClose>
        <Content handleViewOfferLetter={handleOpenSheet} />
      </DialogContent>
    </Dialog>
  )
}

export default OfferLetterAvailableDialog
